<template>
    <div>
        <ResponsiveImage :image-url="idleImage" width="100%"  image-class="idle-image" class="idle-image-container"/>

        <v-row class="ma-4">
            <v-col>
                <h1 class="text-center primary-color hero">
                    {{ $t("results.idle-screen.header") }}
                </h1>
            </v-col>
        </v-row>
        <v-row class="text-center ma-4">
            <v-col>
                <div class="text-center body-1 primary-color">
                    {{ $t("results.idle-screen.body") }}
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                idleImage: require("@/assets/clearchoice/images/idle.jpg"),
            }
        },
    }
</script>

<style lang="scss" scoped>
    .idle-image-container {
        text-align: center;
        margin-left: auto;
        margin-right: auto;
    }

    ::v-deep .idle-image {
        max-width: 954px !important;
        max-height: 637px !important;
    }
</style>
